/* eslint-disable jira/filename-case, jira/naming/disallow-filenames, jira/import-whitelist */
import { loadQuery, type PreloadedQuery } from 'react-relay';
import { consumeDependency } from '@jira/router-resources__utils/src/consumeDependency.tsx';
import QUERY, {
	type KnowledgeHubBrowseAllArticlesContainerQuery,
} from '@jira/servicedesk__knowledge-hub-browse-all-articles/src/__generated__/KnowledgeHubBrowseAllArticlesContainerQuery.graphql.ts';
import {
	createResource,
	type RouterDataContext,
	type ResourceStoreContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { projectIdResource } from './projectIdResource.tsx';

export const knowledgeHubBrowseAllArticlesKBTypeCheckerResource: RouteResource<
	PreloadedQuery<KnowledgeHubBrowseAllArticlesContainerQuery, Record<string, unknown>>
> = // eslint-disable-next-line jira/router/no-daisy-chaining-resources
	createResource<PreloadedQuery<KnowledgeHubBrowseAllArticlesContainerQuery>>({
		type: 'KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES_KB_TYPE_CHECKER',
		depends: [projectIdResource.type],
		getKey: (routerContext) => {
			const projectKey = routerContext.match.params.projectKey;
			return `knowledge-hub-kb-type-checker-${projectKey}`;
		},
		getData: async (dataContext: RouterDataContext, { tenantContext }: ResourceStoreContext) => {
			const { cloudId } = tenantContext;
			const projectKey = dataContext.match.params.projectKey;
			// Use shared project ID resource
			const { dependencies } = dataContext;
			const projectData = await consumeDependency<{ id: string }>(
				dependencies,
				projectIdResource.type,
			);
			if (!projectData?.id) {
				throw new Error(`Failed to get project ID for project key: ${projectKey}`);
			}

			// Construct container using projectId
			const container = `ari:cloud:jira:${cloudId}:project/${projectData.id}`;

			// Use loadQuery to create the preloaded query and return it
			const queryReference = loadQuery<KnowledgeHubBrowseAllArticlesContainerQuery>(
				getRelayEnvironment(),
				QUERY,
				{
					cloudId,
					container,
					isAgentKbEnabled: fg('enable_jsm_agent_kb'),
				},
			);

			return queryReference;
		},
		isBrowserOnly: true,
	});
